import styled from 'styled-components'

export const CheckboxWrapper = styled.div<{ $disabled?: boolean; $isOption: boolean }>`
  display: flex;
  align-items: flex-start;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  position: relative;
  margin-top: ${({ theme, $isOption }) => ($isOption ? 0 : theme.space.S4)};
  width: max-content;
`

export const CheckboxLabel = styled.label<{ $noWrapLabel: boolean; $isOption: boolean }>`
  padding-left: ${({ theme }) => theme.space.S8};
  margin-top: ${({ theme }) => theme.space.S4};
  line-height: 16px;
  pointer-events: none;
  white-space: ${({ $noWrapLabel }) => ($noWrapLabel ? 'nowrap' : 'unset')};
  font-size: ${({ theme }) => theme.fonts.fontSize14};
  font-family: ${({ theme }) => theme.fonts.textCondensedFont};
`

export const CheckboxInput = styled.input.attrs({ type: 'checkbox' })<{ $hasError?: boolean; $isOption: boolean }>`
  position: relative;
  width: 18px;
  height: 18px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }

  &:before {
    content: '';
    position: absolute;
    box-sizing: border-box;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border-radius: 2px;
    border-width: 2px;
    border-style: solid;
    border-color: ${({ theme, $hasError }) => ($hasError ? theme.colors.error : theme.colors.grey)};
    background-color: ${({ theme }) => theme.colors.white};
  }

  &:checked:before {
    background-color: ${({ theme }) => theme.colors.violet};
    border-color: ${({ theme }) => theme.colors.violet};
  }

  &:indeterminate:before {
    background-color: ${({ theme }) => theme.colors.grey};
    border-color: ${({ theme }) => theme.colors.grey};
  }

  &:disabled:before {
    opacity: 0.4;
  }

  &:after {
    content: '';
    position: absolute;
    box-sizing: border-box;
    top: -1px;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    transition: all 0.2s;
  }

  &:not(:checked):after {
    opacity: 0;
    transform: scale(0);
  }

  &:checked:after {
    content: '✔';
    opacity: 1;
    transform: scale(1);
  }

  &:indeterminate:after {
    content: '–';
    top: 0;
    opacity: 1;
    transform: scale(1);
  }
`
